import { crmApiFetch } from "../../services/crmApi";

export async function getDashboardStats(timePeriod, viewMode) {
    const response = await crmApiFetch(`/api/dashboard/stats?period=${timePeriod}&view=${viewMode.toLowerCase()}`, {
        method: 'GET',
    });
    let payload = {};

    try{
        payload = await response.json();
    } catch (error) {
        payload = {};
    }

    if(!response.ok){
        throw new Error(payload.error ||'Failed to fetch dashboard stats');
    }
    return payload;
}